import React from "react";

import styles from "./FavoritesPage.module.scss";
import ProductCard from "../../UI/ProductCard/ProductCard";

const goodsArr = [
  { id: 0, img: "/img/main/temp/1.jpg", title: "Трикотаж WATERPROOF", colors: "2 цвета", price: 998 },
  { id: 1, img: "/img/main/temp/2.jpg", title: "Трикотаж WATERPROOF", colors: "2 цвета", price: 998 },
  { id: 2, img: "/img/main/temp/3.jpg", title: "Трикотаж WATERPROOF", colors: "2 цвета", price: 998 },
  { id: 3, img: "/img/main/temp/4.jpg", title: "Трикотаж WATERPROOF", colors: "2 цвета", price: 998 },
  { id: 3, img: "/img/main/temp/2.jpg", title: "Трикотаж WATERPROOF", colors: "2 цвета", price: 998 },
];

const Favorites: React.FC = () => {
  return (
    <section>
      <div className="container">
        <div className={styles.body}>
          {goodsArr.map((item, index) => (
            <div className={styles.column} key={index + 1}>
              <ProductCard isFavorite={true} img={item.img} price={item.price} colors={item.colors} title={item.title} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Favorites;
